// @flow
import type { StoreState } from 'reducers';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-grab-ui/src';
import { grabLogin } from 'actions/user';

type Props = {
  clientId: string,
  authBaseUrl: string,
  authPath: string,
  grabLogin: Function,
  buttonText: string,
  location: Object,
  history: Object,
  additionalParams: Object,
  shouldLogin: Boolean
};

export class ConcedoLoginButton extends Component {
  props: Props;

  componentDidMount = () => {
    const { location, shouldLogin, grabLogin } = this.props;

    if (location && location.query && location.query.code && shouldLogin) {
      grabLogin(location.query.code);
    }
  };

  handleLoginRequest = () => {
    const { authBaseUrl, authPath, clientId, location } = this.props;

    const concedoAuthUrl = [
      `${authBaseUrl}${authPath}`,
      `?client_id=${clientId}`,
      `&redirect_uri=${encodeURIComponent(window.location.origin + location.pathname)}`,
    ];

    const { redirect } = location.query;
    if (redirect) {
      // Encoding uri twice is required for concedo to not decode the content
      concedoAuthUrl.push(`&state=${encodeURIComponent(encodeURIComponent(redirect))}`);
    } else {
      concedoAuthUrl.push(`&state=${Math.random().toString(36).substr(2, 10)}`);
    }

    window.location = concedoAuthUrl.join('');
  };

  render() {
    return (
      <Button
        style={{ backgroundColor: '#488BE4', color: 'white' }}
        onClick={this.handleLoginRequest}
        {...this.props.additionalParams}
      >
        {this.props.buttonText}
      </Button>
    );
  }
}

export function mapStateToProps(state: StoreState, ownProps: Object) {
  return { ...ownProps };
}

export default connect(mapStateToProps, { grabLogin })(ConcedoLoginButton);
